import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BaseService } from 'src/app/system-common/services/base.service';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { DocumentManagementService } from '../service/document-management.service';
import { DocumentManagementHandlerComponent } from './document-management.handler';

@Component({
  selector: 'sym-document-management',
  templateUrl: './document-management.component.html',
  styleUrls: ['./document-management.component.scss'],
})
export class DocumentManagementComponent extends DocumentManagementHandlerComponent implements OnInit {
  constructor(
    public service: DocumentManagementService,
    public headerService: HeaderService,
    public router: Router,
    public baseService: BaseService,
    public settingService: SettingService
  ) {
    super(service, headerService, router, baseService, settingService);
  }

  ngOnInit() {
    this.service.settingService.removeSessionStorage('ApplicationStatus');
    this.service.settingService.removeSessionStorage('CheckerApplicationStatus');
    super.ngOnInit();
  }
}
